import { render, staticRenderFns } from "./statisticsTotor.vue?vue&type=template&id=0c3c311b&scoped=true&"
import script from "./statisticsTotor.vue?vue&type=script&lang=js&"
export * from "./statisticsTotor.vue?vue&type=script&lang=js&"
import style0 from "./statisticsTotor.vue?vue&type=style&index=0&id=0c3c311b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c311b",
  null
  
)

export default component.exports